import axios, { AxiosInstance, AxiosResponse } from "axios";
import { showLoader, hideLoader } from "./msal";

const defaultHeaders = {
  "Content-Type": "application/json",
};
const getAccessToken = () => {
  const SSOToken = localStorage.getItem("AccessToken");
  const token = SSOToken;
  return token;
};

class httpConfig {
  Axios: AxiosInstance;
  constructor(baseURL: string) {
    this.Axios = axios.create({
      baseURL,
    });
    this.setUpInterceptors();
  }

  setUpInterceptors() {
    this.Axios.interceptors.response.use(
      (response: AxiosResponse) => response,
      (error: any) => {
        const errorData = error?.response?.data || error;
        const errorObj = {
          ...errorData,
          message: errorData?.message?.includes("Already Exists")
            ? errorData?.message
              : "Operation failed. Please try again after some time.",
        };

        if (errorData.correlationId) {
          errorObj.message = `${errorObj.message}\nCode: ${errorData.correlationId}`;
        }

        const errCode = error?.response?.status;
        if (
          errCode === 404 ||
          errCode === 500 ||
          errCode === 400 ||
          errCode === 504
        ) {
          //store.dispatch(hideLoadingSpinner());
          //store.dispatch(setErrorNotification(errorObj));
        }
        if (typeof error?.response === "undefined") {
          // Cross-Origin Request Blocked
          const corsErr = {
            type: "CORB",
            message: "Operation failed. Please try again after some time",
          };
          errorData.push(corsErr);
        }
        throw error;
      }
    );

    this.Axios.interceptors.request.use(
      async (request: any) => {
        request.headers.Authorization = getAccessToken();
        return request;
      },
      (error) => {
        throw error;
      }
    );
  }

  getRequest(url: string,params:any, headers: any = {}) {
    showLoader();
    return this.Axios.get(url, {
      headers: { ...defaultHeaders, ...headers },withCredentials: true
     
    }).then(function (response) {
    //  hideLoader();
      return (response?.data ? response.data : response);
    }).catch(function (error) { hideLoader(); throw error });
  }

  postRequest(url: string, data: any, headers: any = {}) {
    showLoader();
    return this.Axios.post(url, data, {
      headers: { ...defaultHeaders, ...headers }, withCredentials: true,
    }).then(function (response) {
      hideLoader();
      return (response?.data ? response.data : response);
    }).catch(function (error) { hideLoader(); throw error });
  }

  postStringRequest(url: string, data: any, headers: any = {}) {
    showLoader();
    let req = JSON.stringify(data).toString();
    const replaceStr = /"/gi;
    req = req.replace(replaceStr, '\\"');
    return this.Axios.post(url, '"' + req + '"', {
      headers: { ...defaultHeaders, ...headers },withCredentials: true
    }).then(function (response) {
      hideLoader();
      return (response?.data ? response.data : response);
    }).catch(function (error) { hideLoader(); throw error });
  }

  deleteRequest = (url: string, headers: any = {}) =>
    this.Axios.delete(url, {
      headers: { ...defaultHeaders, ...headers },withCredentials: true
    }).then((response) => (response?.data ? response.data : response));

  deleteRequestWithPayload = (url: string, data?: any, headers: any = {}) =>
    this.Axios.delete(url, {
      data,
      headers: { ...defaultHeaders, ...headers },withCredentials: true
    }).then((response) => (response?.data ? response.data : response));

  putRequest = (url: string, data: any = {}, headers: any = {}) => {
    showLoader();
    return this.Axios.put(url, data, {
      headers: { ...defaultHeaders, ...headers },withCredentials: true
    }).then((response) => (response?.data ? response.data : response));
  }

  patchRequest(url: string, data: any, headers: any = {}) {
    return this.Axios.patch(url, data, {
      headers: { ...defaultHeaders, ...headers },withCredentials: true
    }).then((response) => (response?.data ? response.data : response));
  }
}

export default httpConfig;
